define('wax-resist-common',["shims"], function() {

  var resist = {
    init: function(context, w, h) {
      var canvas = context.canvas;
      w = w || canvas.clientWidth;
      h = h || canvas.clientHeight;
      canvas.width = w;
      canvas.height = h;
      context.fillStyle = "transparent";
    },
    loadPattern: function(context, url, c) {
      c = c || function() {};

      var background = new Image();
      background.onload = function() {
        var src = document.createElement("canvas");
        src.width = context.canvas.width;
        src.height = context.canvas.height;
        var srcContext = src.getContext("2d");
        srcContext.drawImage(background, 0, 0, background.width, background.height, 0, 0, src.width, src.height);
        var pattern = context.createPattern(src, "no-repeat");
        context.fillStyle = pattern;
        c();
      };
      background.src = url;
    },
    bindMouse: function(element, context, r) {
      var canvas = context.canvas;
      element.addEventListener("mousemove", function(e) {
        var bounds = element.getBoundingClientRect();
        var x = (e.clientX - bounds.left) / canvas.offsetWidth * canvas.width;
        var y = (e.clientY - bounds.top) / canvas.offsetHeight * canvas.height;
        resist.revealPoly(context, x, y, r);
        resist.speckle(context, x, y, r);
      });
    },
    bindTouch: function(element, context) {
      var canvas = context.canvas;
      element.addEventListener("touchmove", function(e) {
        var bounds = element.getBoundingClientRect();
        for (var i = 0; i < e.touches.length; i++) {
          var touch = e.touches[i];
          var x = (touch.clientX - bounds.left) / canvas.offsetWidth * canvas.width;
          var y = (touch.clientY - bounds.top) / canvas.offsetHeight * canvas.height;
          resist.reveal(context, x, y);
        }
      });
    },
    revealPoly: function(context, x, y, r, alpha) {
      r = r || context.canvas.width / 10;
      context.globalAlpha = alpha;
      context.beginPath();
      var polyLength = 32;
      context.moveTo(x, y + r);
      for (var i = 1; i <= polyLength; i++) {
        var distance = r + (Math.random() - 1) * r * .2;
        var angle = i / polyLength * Math.PI * 2;
        context.lineTo(x + Math.sin(angle) * distance, y + Math.cos(angle) * distance);
      }
      context.fill();
    },
    reveal: function(context, x, y, r, alpha) {
      r = r || context.canvas.width / 10;
      context.globalAlpha = alpha;
      context.beginPath();
      context.arc(x, y, r, 0, Math.PI * 2);
      context.fill();
    },
    speckle: function(context, x, y, r) {
      var size = context.canvas.width * .05 * Math.random();
      size = size % 7;
      var half = size * .5;
      for (var i = 0; i < 20; i++) {
        var angle = Math.random() * Math.PI * 2;
        var dx = Math.cos(angle) * r;
        var dy = Math.sin(angle) * r;
        context.fillRect(x - half + dx, y - half + dy, size, size);
      }
    },
    animate: function(context, animation, f, then) {
      var xStart = animation.start.x;
      var yStart = animation.start.y;
      var xRange = animation.end.x - animation.start.x;
      var yRange = animation.end.y - animation.start.y;
      var began = Date.now();
      var current = 0;
      var duration = animation.duration || 400;
      then = then || function() {};
      var w = context.canvas.width;
      var h = context.canvas.height;

      var frame = function() {
        var now = Date.now();
        var elapsed = now - began;
        var delta = elapsed / duration;
        //frame-skip limiter
        if (delta > current + .05) {
          delta = current + .05;
        }
        current = delta;
        if (delta > 1) return then();
        if (animation.ease) {
          delta = delta * delta;
        }
        var x = (xStart + xRange * delta) * w;
        var y = (yStart + yRange * delta) * h;
        f(x, y);
        window.requestAnimationFrame(frame);
      };
      frame();
    }
  };

  return resist;

});
